import React from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';

const InfoNeededScreen = props => {
  return (
    <Layout product='ica'>
      <PageHeader title='Before You Start'>
        <div>
          <h1>Overview</h1>
          <p>
            The DreamEx Connect Introductory Company Assessment is designed to provide a very high-level,
            initial assessment of your organization and is <b><u>NOT</u></b> designed to provide a valuation
            figure of your organization. The purpose of this product is to correctly evaluate and properly route
            applicants to the appropriate listing track program based on an assessment of three strategic
            areas:
          </p>
          <ol>
          <li>the type of products and services commercially available;</li>
          <li>the financial state of the organization.</li>
          </ol>

          <p>The following sections outline the information that is requested to successfully complete the assessment.</p>
          <div style={{marginLeft: '2em'}}>
            <h2>Questionnaire</h2>
            <p>The final section of this assessment is a questionnaire to better understand the products and services of the organization and the current state of the various functional areas of the organization. The information needed to answer the questions in each of the sections are described below.</p>
            <div style={{marginLeft: '2em'}}>
              <h3><i>General Information</i></h3>
              <ul>
              <li>The legal entity structure of the organization? (i.e., LLC, C-Corp, LLP, etc.)</li>
              <li>The state and date of incorporation or registration of the organization.</li>
              <li>The number of products or product areas you wish to include in the assessment (about 5 max)</li>
              <li>The number of sevices or service areas you wish to include in the assessment (about 5 max)</li>
              <li>The total number of full-time employee equivalents (“FTE”). (The concept of an FTE is used to convert the hours worked by several part-time employees into the hours worked by a full-time employee.)</li>
              </ul>

              <h3><i>Product/Service</i></h3>
              <p>The Initial Company Assessment evaluates the various products and services of the organization individually. For those organization with many products or services, consider combining and grouping similar products and services together for expediency and best results. For example, products may be grouped according to customer, industry usage or any other logical consideration. For each product/product line and service/service line, please be prepared to answer the following:</p>
              <ul>
                <li>The length of time the product/service has been sold to the public (or how long before it will be sold).</li>
              </ul>

              <h3><i>Intellectual Property</i></h3>
              <p>Intellectual property is a critical asset of any organization and includes patents, trademarks, industrial designs, trade secrets, and copyrights. In this section, please be prepared to answer the following:</p>
              <ul>
                <li>The list of any patent numbers.</li>
                <li>The estimated value of all intellectual property assets owned by the organization.</li>
                <li>The estimated cost expended by the organization to develop all of the intellectual property assets currently owned by the organization.</li>
              </ul>

              <h3><i>Sales and Marketing</i></h3>
              <p><u>For each product/product and service/service line identified above</u>, please be prepared to answer the following: </p>
              <ul>
                <li>The average time to make a sale from initial customer contact to purchase.</li>
                <li>The average sale price of the product/product line or service/service line.</li>
                <li>The percentage of total annual sales of the specific product or service purchased by the top 10 customers.</li>
                <li>The total number of customers (past and present).</li>
                <li>The total number of units sold in the last 12 months.</li>
                <li>The total number of units forecasted to sell in the next 12 months.</li>
                <li>Hypothetically, the maximum number of units that could realistically be <b><u><i>sold, produced and delivered to the customer</i></u></b> in one year based on the current configuration of the company.</li>
                <li>Hypothetically, the total population of customer that could realistically purchase the product or service at any point in the future. The idea is to determine the total number of potential customers for the product or service.</li>
              </ul>

              <h3><i>Finance</i></h3>
              <ul>
                <li>The fiscal year end date of the organization.</li>
                <li>The total revenue amount at the end of the last fiscal year.</li>
                <li>The total year to date revenue for this current fiscal year. It is important to know the date of the revenue figure.</li>
                <li>The total gross profit amount at the end of the last fiscal year.</li>
                <li>The total year to date gross profit for this current fiscal year. It is important to know the date of the gross profit figure.</li>
                <li>The total net operating profit amount at the end of the last fiscal year.</li>
                <li>The total year to date net operating profit for this current fiscal year. It is important to know the date of the net operating profit figure.</li>
                <li>The average amount of cash needed per month to pay the non-production expenses of the company.</li>
                <li>The total amount of cash immediately available for the company. This amount would not include working lines of credit since those should be reserved for the payment of production-related expenditures. </li>
                <li>The date (if ever) working capital was borrowed to pay for general administrative expenses (non-production related expenses).</li>
                <li>The total amount of investor funds raised to date.</li>
                <li>An estimated amount of additional money (debt and/or equity) needed to maximize the full commercial potential of the company's products/ideas.</li>
              </ul>

              <h3><i>Production and Quality Control</i></h3>
              <p>The Initial Company Assessment evaluates the production and quality control for the product/product lines and service/service lines identified earlier. For each product/product line and service/service line, please be prepared to answer the following:</p>
              <ul>
                <li>The cost to produce (deliver) one unit of the company's product (or service)</li>
                  <li>The percentage of the unit cost that is labor-related</li>
                  <li>Time it takes to produce/deliver one unit of the product/service</li>
                </ul>

                <p>In addition, be prepared to answer the following general production and quality control questions:</p>
                <ul>
                  <li>List of all significant certifications and/or standard designations possessed by the company (if any)</li>
                  <li>The total number of hours per week typically available for production-related activities. The maximum number is 168 which is the number of hours in a 24/7 production facility.</li>
              </ul>
            </div>
          </div>
          <h1>What's Next</h1>
          <p>For those companies exceeding the minimal ICA score, the next step is a discussion with a DreamEx Connect representative to develop a customized program to optimize the functional areas identified in the ICA that represent an opportunity to enhance the likelihood, timing and pricing your venture shares as a Listing Candidate on the Dream Exchange.</p>
        </div>
      </PageHeader>
    </Layout>
  )
}
export default InfoNeededScreen
